import styled from "styled-components";

export const FormContainer = styled.div`
  width: 80%;
  margin: 0 auto;
`;
